import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

const LINKS = [
  { href: "#mission", label: "Mission" },
  { href: "#program", label: "The Program" },
  { href: "#impact", label: "Impact" },
  { href: "#involved", label: "Get Involved" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

export default function Navigation({ onDonate }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-slate-200"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link
            to="/"
            data-testid="nav-logo"
            className="flex items-center group"
          >
            <img
              src="/hero/logo-p2f.png?v=3"
              alt="Play 2 Fitness"
              className="h-14 md:h-16 w-auto object-contain transition-transform group-hover:scale-105"
            />
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm font-semibold text-slate-700 hover:text-brand-coral transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Button
              data-testid="nav-donate-btn"
              onClick={onDonate}
              className="hidden sm:inline-flex rounded-full bg-brand-coral hover:bg-brand-coralDark text-white font-bold px-6 h-11 shadow-lg shadow-orange-500/20 hover:-translate-y-0.5 transition-all"
            >
              <Heart className="w-4 h-4 mr-2 fill-white" />
              Donate
            </Button>
            <button
              data-testid="nav-mobile-toggle"
              className="md:hidden p-2 text-brand-navy"
              onClick={() => setOpen(!open)}
              aria-label="Toggle menu"
            >
              {open ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-slate-200 px-4 py-4 space-y-3">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => setOpen(false)}
              className="block text-base font-semibold text-slate-800 py-2"
            >
              {l.label}
            </a>
          ))}
          <Button
            data-testid="nav-donate-mobile"
            onClick={() => {
              setOpen(false);
              onDonate && onDonate();
            }}
            className="w-full rounded-full bg-brand-coral hover:bg-brand-coralDark text-white font-bold"
          >
            <Heart className="w-4 h-4 mr-2 fill-white" />
            Donate Now
          </Button>
        </div>
      )}
    </header>
  );
}
